<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  interface Props {
    level: number; // 0..1
    muted?: boolean;
  }

  let { level, muted = false }: Props = $props();

  // Ограничиваем 0..100%, чтобы верхний хвост analyser не ломал вёрстку.
  const width = $derived(Math.max(0, Math.min(100, level * 100)));
</script>

<div class="w-full h-1 bg-white/5 rounded-full overflow-hidden">
  <div
    class="h-full rounded-full transition-all duration-100 {muted
      ? 'bg-red-400/60'
      : 'bg-gradient-to-r from-green-400 to-emerald-300'}"
    style:width="{width}%"
  ></div>
</div>
